export default __webpack_public_path__ + "static/media/Pruebas.e7f9230a.svg";